let SITE_PATH_PREFIX: string = '';

const setMeetingPlacePrefix = (prefix: string) => {
  SITE_PATH_PREFIX = prefix || 'en';
};
const getMeetingPlacePrefix = () => {
  return SITE_PATH_PREFIX;
};

const DEFAULT_LOCALE: string = 'en';

const getDefaultLocale = () => {
  return DEFAULT_LOCALE;
};

export {
  getMeetingPlacePrefix,
  setMeetingPlacePrefix,
  getDefaultLocale,
  DEFAULT_LOCALE,
};
